import * as React from 'react';
import { useAdaptedComponents } from '../../hooks/useAdaptedComponents';
import { CustomPaymentMethodList } from '../CustomPaymentMethodList';
import { SavedCreditCardsList } from '../SavedCreditCardsList';
import { PaymentMethodsListProps } from './types';

export const PaymentMethodsListView: React.FC<PaymentMethodsListProps> = (
  props
) => {
  const AdaptedComponents = useAdaptedComponents();
  if (AdaptedComponents) {
    return <AdaptedComponents.PaymentMethodsList {...props} />;
  }

  return (
    <div data-hook="wcn-step-paymentMethod">
      {props.creditCards.length > 0 && (
        <SavedCreditCardsList
          activePaymentComponentNode={props.activePaymentComponentNode}
          creditCards={props.creditCards}
          selectedCardId={props.selectedCardId}
          theme={props.theme}
          onChange={props.onSavedCreditCardChanged}
        />
      )}
      <CustomPaymentMethodList
        activePaymentComponentNode={props.activePaymentComponentNode}
        paymentMethods={props.paymentMethods}
        selectedMethod={props.selectedMethod}
        theme={props.theme}
        locale={props.locale}
        onChange={props.onPaymentMethodChanged}
      />
    </div>
  );
};
